import { api } from "./api";

export interface SalesBalanceResponse {
  balance: number;
  expectedBalance: number;
  currentMonth: {
    month: number;
    year: number;
    expectedVolume: number;
    expectedCommission: number;
    expectedBonuses: number;
    actualVolume: number;
    actualCommission: number;
    actualBonuses: number;
    salaryReceived: number;
    totalEarned: number;
    totalSalesVolume?: number;
    commissionEarned?: number;
    bonusesEarned?: number;
  };
  ordersCount: number;
  recentTransactions: {
    actual: SalesTransaction[];
    expected: SalesTransaction[];
    all: SalesTransaction[];
  };
  nextBonus: {
    targetVolume: number;
    rewardValue: number;
    rewardMode: string;
    progress: number;
    remaining: number;
  } | null;
  salary: {
    amount: number;
    currency: string;
  };
  tariffRules: any[];
}

export interface SalesTransaction {
  _id: string;
  userId: string;
  userName: string;
  type: string;
  amount: {
    USD: number;
    TJS: number;
  };
  currency: string;
  description: string;
  balanceType: "actual" | "expected";
  relatedOrderId?: string;
  relatedTransactionId?: string;
  month: number;
  year: number;
  createdAt: string;
  updatedAt: string;
}

export const salesApi = {
  // Получить баланс и статистику продажника
  getSalesBalance: async (): Promise<SalesBalanceResponse> => {
    const response = await api.get("/sales/balance");
    return response.data;
  },

  // Получить историю по месяцам
  getSalesMonthlyHistory: async (params?: { limit?: number }) => {
    const response = await api.get("/sales/history", { params });
    return response.data;
  },

  // Получить детальный отчет за месяц
  getSalesMonthDetail: async (params: { month: number; year: number }) => {
    const response = await api.get("/sales/month-detail", { params });
    return response.data;
  },

  // Получить транзакции продажника (для админов/менеджеров)
  getSalesUserTransactions: async (userId: string, params?: { limit?: number }) => {
    const response = await api.get(`/sales/${userId}/transactions`, { params });
    return response.data;
  },
};

